"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _settingsResolver = _interopRequireDefault(require("../../settingsResolver"));

var processAuthServerResponse = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(baseSettings, callbackUrl) {
    var verifier, q, settings, body;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // do we have a verifier present? If not, user may have landed directly on this page
            verifier = localStorage.getItem('pkce_code_verifier');

            if (verifier) {
              _context.next = 3;
              break;
            }

            throw new Error('Code verifier set prior to redirect is not present');

          case 3:
            q = new URLSearchParams(window.location.search);

            if (q.has('code')) {
              _context.next = 6;
              break;
            }

            throw new Error('Incorrect response from server - code not supplied');

          case 6:
            _context.next = 8;
            return (0, _settingsResolver.default)(baseSettings);

          case 8:
            settings = _context.sent;
            // Exchange the authorization code for an access token
            body = new URLSearchParams();
            body.append('client_id', settings.clientId);
            body.append('code', q.get('code'));
            body.append('scope', 'openid');
            body.append('grant_type', 'authorization_code');
            body.append('code_verifier', localStorage.getItem('pkce_code_verifier')); // not sure why we need this on this fetch post request, but server validates it

            body.append('redirect_uri', "".concat(window.location.origin).concat(callbackUrl));
            return _context.abrupt("return", fetch(settings.token, {
              method: 'post',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: body.toString()
            }).then(function (data) {
              if (!data.ok) {
                throw new Error(data.statusText);
              }

              return data.json();
            }).then(function (response) {
              // Clean localStorage up, don't need this any more
              localStorage.removeItem('pkce_code_verifier');
              sessionStorage.setItem('auth.accessToken', response.access_token);
              sessionStorage.setItem('auth.refreshToken', response.refresh_token);
            }).catch(function () {
              // This could be an error response from the OAuth server, or an error because the
              // request failed such as if the OAuth server doesn't allow CORS requests
              throw new Error('failed to obtain access token from server');
            }));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function processAuthServerResponse(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = processAuthServerResponse;
exports.default = _default;